module.exports = __webpack_public_path__ + "static/media/UnionPay.0e5198d9.svg";